import { Box, Text } from "@chakra-ui/react";

import Card from "components/Card/Card";

export default function Terms() {
  const number = (
    <Box
      display="flex"
      alignItems="center"
      width="15.25rem"
      height="3.25rem"
      bgColor="transparent"
      position="fixed"
      bottom="1rem"
      zIndex={99}
      pl={4}
    >
      <Text variant="caption" color="black">
        4889-8087-9214.8
      </Text>
    </Box>
  );
  return (
    <Box pt={3} bgColor="white">
      <Box align="center">
        <Text variant="h1" color="black">
          Dealer Alchemist LLC
        </Text>
        <Text variant="h4" color="black" py={3}>
          Terms & Conditions
        </Text>
      </Box>
      <Card sx={{ mx: "auto", maxWidth: "75%", bgColor: "#d4d4d4" }}>
        <Box px={3}>
          <Text variant="body2" color="black">
            <strong>1.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Scope.</u>
            </strong>{" "}
            These Terms and Conditions (the{" "}
            <strong>
              <i>“Terms”</i>
            </strong>{" "}
            ) are incorporated into that certain Master Software License and
            Service Agreement (the{" "}
            <strong>
              <i>“Agreement”</i>
            </strong>{" "}
            ) entered into between you as the dealership and/or on behalf of the
            dealership that you own ({" "}
            <strong>
              <i>“you”</i>
            </strong>{" "}
            or{" "}
            <strong>
              <i>“your”</i>
            </strong>{" "}
            ) and Dealer Alchemist LLC, a Delaware limited liability company
            (the{" "}
            <strong>
              <i>“Company”</i>
            </strong>{" "}
            ), and govern your use of the Company’s software as a service (the{" "}
            <strong>
              <i>“Software”</i>
            </strong>{" "}
            ) and any other products or services the Company provides to you,
            including website services (together with the Software, the{" "}
            <strong>
              <i>“Services”</i>
            </strong>{" "}
            ). Any special requirements, modifications or amendments mutually
            agreed to and not otherwise addressed in the Agreement or these
            Terms may be set forth in a separate addendum (the{" "}
            <strong>
              <i>“Addendum”</i>
            </strong>{" "}
            ), which shall be incorporated into the Agreement and subject to
            these Terms. These Terms prevail over any general terms and
            conditions, regardless of any terms and conditions that might have
            been submitted by you with a request for a quote.
          </Text>
          <Text variant="body2" color="black">
            <sup>1</sup> The Company is the successor to the business interests
            of both Kirin Consulting, LLC and Dealer Venom LLC.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>2.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>License.</u>
            </strong>{" "}
            The Company grants you a non-exclusive, non-transferable,
            non-sublicensable, revocable license during the Term (as defined in{" "}
            <u>Section 9</u>) to use the Services you order, subject to your
            complying with these Terms and all applicable federal and state laws
            and regulations (
            <strong>
              <i>“Applicable Law”</i>
            </strong>{" "}
            ). Use of any of the Company’s Services constitutes acceptance of
            these Terms. You appoint the Company as your non-exclusive
            advertising agent during the Term and agree not to allow
            unauthorized third parties to access or use any of the Company’s
            Services.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>3.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Service Ordering and Pricing.</u>
            </strong>{" "}
            The Company offers multiple service packages which includes access
            to its Software for a fixed monthly recurring fee. The Company
            offers additional Services, which you may order, and adjust the
            spend on, on a monthly basis. Pricing for the Company’s Software
            packages and other Services is set forth in the Agreement. Changes
            you request to specific Services, including cancellation, may
            require advance notice. No custom work is performed unless set forth
            in an Addendum or a specific statement of work. The Company may
            update its Services as it deems necessary or desirable to enhance
            the quality or performance of the Services or to comply with
            Applicable Law. Although some of the Services may be provided by its
            affiliates or subcontractors; the Company remains responsible for
            any Services performed by them to the same extent as if it performed
            such Services itself.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>4.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Prepayment for Certain Services.</u>
            </strong>{" "}
            You are responsible for prepaying the Company’s good faith estimate
            of all charges for Services for the following month, including
            charges anticipated to be payable to any third-parties (e.g.,
            Google, Bing, Facebook), relating to advertising (the{" "}
            <strong>
              <i>“Advertising Services”</i>
            </strong>{" "}
            ) before the Company is obligated to perform such Advertising
            Services. The amounts of such prepayment will be reflected on an
            invoice sent to you subject to the terms of Section 5 below. At the
            end of each month, the Company will calculate the total charges for
            Adverting Services actually incurred, and the Company will reconcile
            such amount against your prepayment by either debiting or crediting
            any underpayment or overpayment, respectively, against the following
            month’s invoice for estimated Advertising Services. In the event the
            Agreement is terminated, any remaining debits related to the
            estimation of Advertising Services will be due and payable by you
            and any remaining credits related to the estimation of Advertising
            Services will be refunded to you by the Company.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>5.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Billing.</u>
            </strong>{" "}
            Invoices are sent electronically, and you agree to pay within 15
            days of receipt, without setoff, deduction or delay. Any invoice
            amount paid by credit card will incur a 2.8% surcharge. Late
            payments will accrue interest at the lesser of 5% per month or the
            maximum legally permitted rate. You are responsible for paying all
            federal, state, local or other applicable taxes (other than on the
            Company’s net income) that the Company is or in the future may be
            required to collect or pay with respect to the Services provided to
            you. You shall be responsible for paying third party advertisers
            directly, unless the invoice indicates that you shall reimburse the
            Company for making such payments for you, which will be invoiced
            accordingly, subject to <u>Section 4</u> of these Terms. Your
            payment obligations are not contingent on your receipt of any
            manufacturer, third party incentives, co-op or other funds. During
            the Term, the Company may increase fees upon 30 days’ prior notice
            if its costs (e.g., postal rates; third party provider charges)
            increase. Unless otherwise required by an OEM certified program, the
            Company may increase fees annually by up to 3%, effective on the 1st
            of each calendar year. The Company will charge a one-time Tech
            Integration fee of $995, which will apply to the Term and all
            subsequent Terms (as defined below). The Company may suspend any or
            all of aspects of the Services, upon notice, if you fail to pay all
            amounts owed when due that are not disputed in good faith with a
            description of the basis for such dispute; any billing disputes not
            submitted to the Company within 30 days of receipt of invoice will
            be waived. You are responsible for any collection costs, including
            reasonable attorneys’ fees.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>6.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Intellectual Property.</u>
            </strong>{" "}
            <Box pl={"70px"} pt={2} color="black">
              <ol type="a">
                <li>
                  <u>General.</u> All intellectual property rights, including
                  copyrights, patents, patent disclosures and inventions
                  (whether patentable or not), trademarks, service marks, trade
                  secrets, know-how and other confidential information, trade
                  dress, trade names, logos, corporate names, and domain names,
                  together with all of the goodwill associated therewith,
                  derivative works and all other rights (collectively,{" "}
                  <strong>
                    <i>“Intellectual Property Rights”</i>
                  </strong>{" "}
                  ) in and to all documents, work product, and other materials
                  that are delivered to you under this Agreement or prepared by
                  or on behalf of the Company in the course of performing the
                  Services (collectively, the{" "}
                  <strong>
                    <i>“Deliverables”</i>
                  </strong>{" "}
                  ) shall be owned by the Company, except for any of your
                  Confidential Information or Customer IP (each as defined
                  herein). The Company hereby grants you a license to use all of
                  its Intellectual Property Rights free of additional charge and
                  on a non-exclusive, worldwide, non-transferable,
                  non-sublicensable, fully paid-up, royalty-free, and perpetual
                  basis to the extent necessary to enable you to make reasonable
                  use of the Software and the Services, solely during the Term.
                  You may not decompile, disassemble, reverse engineer or
                  otherwise attempt to reconstruct or create derivative products
                  from the Company’s Services; nor may you remove any trademark
                  or copyright symbols. You retain all Intellectual Property
                  Rights you hold in content you submit to the Company for use
                  in the Services, including the right to your domain name URL
                  if the Company hosts your primary website, even if the Company
                  registers it on your behalf (collectively, the{" "}
                  <strong>
                    <i>“Customer IP”</i>
                  </strong>{" "}
                  ). You will grant the Company a non-exclusive, revocable,
                  non-transferable, non-sublicensable, royalty-free license
                  during the Term to use such Customer IP in connection with
                  providing the Services. Third parties who provide images for
                  use in the Services hold the copyrights thereto.
                </li>
                &nbsp;
                <li>
                  <u>Exclusive Rights.</u> The Company will have the exclusive
                  rights in making any derivative works from any of its work,
                  practices, coding, or programming arising out of the Services.
                </li>
                &nbsp;
                <li>
                  <u>Your Rights.</u> You shall retain all of your Intellectual
                  Property Rights in any text, images or other components you
                  own and deliver to the Company for use on any website that is
                  developed under this Agreement. Any domain name registered on
                  your behalf will be registered in your name for both the
                  billing and administrative contacts and you shall be
                  responsible for renewing your domain name(s).
                </li>
                &nbsp;
                <li>
                  <u>Acknowledgment.</u> Both parties acknowledge and agree
                  that, except as specifically set forth in this Agreement,
                  neither party shall acquire under this Agreement any rights of
                  use or ownership with respect to any Intellectual Property
                  Rights of the other party or its licensors, and all such
                  Intellectual Property Rights shall remain the property of its
                  respective owner.
                </li>
              </ol>
            </Box>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>7.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Confidentiality.</u>
            </strong>{" "}
            As used herein,{" "}
            <strong>
              <i>“Confidential Information”</i>
            </strong>{" "}
            means all non-public, confidential or proprietary information,
            including, but not limited to, trade secrets, technology,
            information pertaining to business operations and strategies, and
            information pertaining to customers, pricing, and marketing
            disclosed by one party (the{" "}
            <strong>
              <i>“Discloser”</i>
            </strong>{" "}
            ) to the other (the{" "}
            <strong>
              <i>“Recipient”</i>
            </strong>{" "}
            ) and that is (i) identified as confidential, (ii) information that
            derives from or reveals any Confidential Information, and (iii)
            information that, based on its nature and the circumstances
            surroundings its disclosure, a reasonable person would consider
            confidential or proprietary, including information disclosed by a
            party prior to the effective date of the Agreement. Confidential
            Information does not include information that: (a) was already in
            Recipient’s possession when first disclosed by Discloser; (b) was in
            the public domain when disclosed to Recipient or enters the public
            domain through no fault of Recipient; (c) is made available by
            Discloser to a third party on an unrestricted, non-confidential
            basis; (d) was lawfully obtained by Recipient from a third party not
            under confidentiality obligations to Discloser; (e) was
            independently developed by Recipient by persons without access to or
            use of Discloser’s Confidential Information or Intellectual Property
            Rights; or (f) is required to be disclosed under any Applicable Law,
            provided, to the extent legally permissible, Recipient notifies
            Discloser prior to such disclosure to enable Discloser to seek
            confidential treatment. With respect to each other’s Confidential
            Information, both parties shall: (i) maintain its confidentiality in
            accordance with reasonable standards; (ii) use it solely in
            connection with the Agreement; (iii) limit access to those who
            require it to perform their obligations under the Agreement; and
            (iv) require that anyone with access be subject to confidentiality
            requirements no less restrictive than those contained here.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>8.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Data Safeguards.</u>
            </strong>{" "}
            Nonpublic Personal Information (
            <strong>
              <i>“NPI”</i>
            </strong>{" "}
            ) has the meaning ascribed to it under the Gramm-Leach-Bliley Act (
            <strong>
              <i>“GLBA”</i>
            </strong>{" "}
            ). Each party represents and warrants that, with respect to any NPI
            it may have access to under the Agreement, it will: (a) comply with
            all requirements under Applicable Law for maintaining its security;
            (b) use it only as necessary to perform its obligations under the
            Agreement; (c) obtain in advance all authorizations necessary to
            provide it to the other party and permit such party to collect and
            use it in accordance with the Agreement; and (d) not provide it to
            any third party unless authorized, and then only if such party is
            bound by compliance requirements no less restrictive than those
            contained here. You further represent and warrant that you have
            obtained, and will maintain, all necessary customer consents
            permitting the Company to communicate to your customers on your
            behalf and will promptly inform the Company of all customer “do not
            contact” and “data deletion” requests. In the event a party fails to
            comply with obligations under Applicable Law for maintaining the
            security of NPI, resulting in unauthorized access to or acquisition
            of NPI that would trigger customer notification under Applicable Law
            (a{" "}
            <strong>
              <i>“Security Breach”</i>
            </strong>{" "}
            ), the party with the Security Breach will promptly notify the other
            party, and any third parties required by Applicable Law, and
            cooperate in responding to such Security Breach. You are responsible
            for establishing the terms governing the use of any NPI generated by
            the Services. Under the California Consumer Privacy Act (
            <strong>
              <i>“CCPA”</i>
            </strong>{" "}
            ), the Company acts as your service provider, and agrees to process
            Personally Identifiable Information (
            <strong>
              <i>“PII”</i>
            </strong>{" "}
            ), as defined in the CCPA, solely on your behalf for the purposes
            outlined in the Agreement and not to use or disclose the PII for any
            other purpose. With respect to any consumer-facing web or
            mobile-based applications the Company provides you, you agree that
            the Company may post a privacy policy and terms governing consumers
            use of such platforms. You are responsible for complying with these,
            as well as any others consumer policies you may establish. The
            Company makes no representations that its privacy practices comply
            with the laws of any jurisdictions outside of the United States (
            <strong>
              <i>“U.S.”</i>
            </strong>{" "}
            ). If you choose to provide the Company with NPI from outside the
            U.S., you do so at your own risk and are responsible for compliance
            with any applicable foreign laws. You grant the Company and its
            authorized subcontractors the right to access and process Dealer
            Data on your behalf and only as necessary to provide the Services.
            The Company maintains administrative, technical and physical
            safeguards to protect the security and confidentiality of Dealer
            Data, including NPI, as required by Applicable Law and in accordance
            with industry standards; the Company contractually requires the same
            of its subcontractors and is responsible for their actions. “Dealer
            Data” means any information about your customers and prospective
            customers, which may include NPI, and any other proprietary data
            stored on your systems or networks.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>9.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>SMS Messaging Terms.</u>
            </strong>{" "}
            <strong>
              Program Name & Purpose:
            </strong>
            Dealer Alchemist SMS Alerts provide demo scheduling confirmations, reminders, and related updates. Example Messages: “Your Dealer Alchemist demo is confirmed for [date/time].
            Reply STOP to cancel or HELP for help.” Message Frequency Message
            frequency varies. Msg & data rates may apply. Opt-Out & Support
            Reply STOP at any time to cancel. Reply HELP for help. 
            &nbsp;
            <p>
            Consent: Consent to receive SMS messages is not a condition of purchase.
            Carrier Disclaimer Carriers are not liable for delayed or
            undelivered messages. Contact For support, email
            support@dealeralchemist.com.
            </p>
            &nbsp;
            <p>
            We will not share your opt-in to an SMS campaign with any third party for purposes unrelated to providing you with the services of that campaign. We may share your Personal Data, including your SMS opt-in or consent status, with third parties that help us provide our messaging services, including but not limited to platform providers, phone companies, and any other vendors who assist us in the delivery of text messages.
            </p>
            &nbsp;&nbsp;
            <p>
            All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.
            </p>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>10.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Term and Termination.</u>
            </strong>{" "}
            The initial term is set forth on the Agreement and commences upon
            the effective date thereof, unless a different period is stated in
            an Addendum or is required pursuant to an OEM certified program (the{" "}
            <strong>
              <i>“Term”</i>
            </strong>{" "}
            ). Unless otherwise agreed, upon expiration of the initial Term the
            Agreement will continue on a month-to-month basis, unless you notify
            the Company of non-renewal in writing mailed to the Company’s
            address at least 30 days prior to the end of the then current Term.
            For any Terms that are month-to-month, a cancellation notice in
            writing mailed to the Company’s address received during a given
            month shall result in termination of Services at the end of the
            following month. Either party may terminate the Agreement: (a) for a
            breach by the other party not cured within 30 days of notice by the
            non-breaching party; or (b) immediately upon notice if the other
            party: (i) voluntarily commences or has instituted against it, and
            not dismissed within 60 days, bankruptcy or similar proceedings;
            (ii) makes an assignment of all or substantially all of its assets
            for the benefit of its creditors; (iii) generally fails to pay its
            debts when due; or (iv) dissolves or ceases to do business. The
            Company may terminate the Agreement upon 5 days’ written notice if
            you fail to pay all amounts owed when due under any agreement with
            the Company, other than those subject to a good faith business
            dispute. Upon termination or expiration of the Agreement: (w) all
            licenses granted hereunder shall terminate; (x) your right to access
            the Services, including the Software, shall cease; (y) the Company
            shall cease using Dealer Data in its possession; and (z) each party
            shall cease using and return or destroy (except for backup copies
            made in accordance with normal document retention policies) the
            other party’s IP and Confidential Information in its possession.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>11.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Representations and Warranties.</u>
            </strong>{" "}
            <Box pl={"70px"} pt={2} color="black">
              <ol type="a">
                <li>
                  <u>Mutual.</u> Each party represents and warrants that: (i) it
                  is duly organized, validly existing, and in good standing
                  under the laws of its jurisdiction of formation; (ii) the
                  Agreement, when executed and delivered, will constitute a
                  valid and binding obligation of such party, enforceable in
                  accordance with its terms; (iii) the performance of its
                  obligations under the Agreement will not knowingly violate any
                  other agreement between such party and any third party; (iv)
                  it has obtained and will maintain all consents, approvals,
                  licenses or other authorizations necessary to perform its
                  obligations under the Agreement; and (v) the execution and
                  performance of the Agreement will not conflict with or violate
                  any Applicable Law.
                </li>
                &nbsp;
                <li>
                  <u>By The Company.</u> The Company represents and warrants
                  that it will provide the Services in a professional manner in
                  accordance with industry standards.
                </li>
                &nbsp;
                <li>
                  <u>By You.</u> You acknowledge and agree that Services
                  provided by third parties or third-party tools integrated into
                  the Services may be subject to the policies and terms of such
                  third parties (e.g., social media platforms, search engines,
                  websites or network publishers on which your advertisements
                  are posted or displayed), and you represent and warrant that
                  you will comply with any such applicable policies and terms.
                  If you provide the Company with any content or other Customer
                  IP to use in connection with the Services, you represent and
                  warrant that such use is authorized, will not constitute false
                  advertising and will not misappropriate, infringe or otherwise
                  violate any third-party rights. You represent to the Company
                  and unconditionally guarantee that (i) any elements of text,
                  graphics, photos, designs, trademarks, or other artwork
                  furnished to the Company for inclusion in any website
                  developed under this Agreement are owned by you, or that you
                  have permission from the rightful owner to use each of these
                  elements, and will hold harmless, protect, indemnify, and
                  defend the Company and its subcontractors from any liability
                  (including attorneys’ fees and court costs), including any
                  claim or suit, threatened or actual , arising from the use of
                  such elements furnished by you; (ii) it will not reverse
                  engineer, decompile, disassemble or attempt to reconstruct,
                  identify or discover any source code, underlying ideas or
                  algorithms of any Intellectual Property Rights of the Company
                  or create or attempt to create derivative works therefrom; and
                  (iii) you shall not acceptor use the website or services to
                  create a competitive product, or permit a third party to use
                  the website to create a competitive product.
                </li>
              </ol>
            </Box>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>12.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Limited Warranty; Disclaimer of Warranties.</u>
            </strong>{" "}
            <strong>
              EXCEPT FOR THE COMPANY WARRANTY SET FORTH IN <u>SECTION 10(b)</u>{" "}
              ABOVE AND BELOW IN THIS <u>SECTION 11</u>, THE COMPANY MAKES NO
              WARRANTY WHATSOEVER WITH RESPECT TO THE SOFTWARE OR SERVICES,
              INCLUDING ANY (A) WARRANTY OF MERCHANTABILITY; OR (B) WARRANTY OF
              FITNESS FOR A PARTICULAR PURPOSE; OR (C) WARRANTY OF TITLE; OR (D)
              WARRANTY AGAINST INFRINGEMENT OF INTELLECTUAL PROPERTY RIGHTS OF A
              THIRD PARTY; WHETHER EXPRESS OR IMPLIED BY LAW, COURSE OF DEALING,
              COURSE OF PERFORMANCE, USAGE OF TRADE, OR OTHERWISE. THE COMPANY
              MAKES NO REPRESENTATIONS OR WARRANTIES THAT THE SERVICES WILL BE
              UNINTERRUPTED OR ERROR FREE,WARRANTIES OF NON-INFRINGEMENT AND ANY
              WARRANTIES ARISING FROM A COURSE OF DEALING, USAGE OR TRADE
              PRACTICE. YOU ACKNOWLEDGE THERE ARE INHERENT RISKS IN INTERNET
              CONNECTIVITY THAT COULD RESULT IN THE LOSS OF CLIENT PRIVACY AND
              PROPERTY, INCLUDING CONFIDENTIAL INFORMATION. EXCEPT AS EXPRESSLY
              STATED HEREIN, THE SERVICES SHALL BE DELIVERED BY THE COMPANY AND
              ACCEPTED BY YOU “AS IS” AND “AS AVAILABLE.”{" "}
              <b>
                The Company’s sole and exclusive liability and your sole and
                exclusive remedy for breach of the limited warranty set out in
                this Section shall be re-performance of the affected Services.
                If we cannot re-perform the Services in compliance with the
                warranty set forth above within a reasonable time (no more than
                30 days) after your written notice of such breach, we shall
                refund to you a portion of the fees previously paid by you
                corresponding to the defective Services. You acknowledge that we
                will not be responsible for your failure to achieve any specific
                results, productivity, or any other measurable performance
                metric. You acknowledge that we shall have no responsibility for
                any third party disrupting, intruding or otherwise copying files
                in part or in whole on all or any part of the Services performed
                for your website and the Company is not responsible for any lost
                files or any other loss that may occur in the operation of the
                website developed and implemented under the terms this
                Agreement.
              </b>
            </strong>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>13.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Additional Disclaimers.</u>
            </strong>{" "}
            The Company exercises no control over, and accepts no responsibility
            for, any third-party services or equipment outside its control, such
            as internet access and computer or network equipment, all of which
            are your responsibility. Accordingly, the Company does not warrant
            that the Services will be uninterrupted, secure, or error-free. Nor
            does it warrant that any specific results will be obtained from the
            use of its Services. You agree to cooperate to enable the Company to
            provision the Services and are responsible for reviewing all
            advertising materials to confirm they comply with Applicable Law.
            The Company strives to ensure the information it provides is both
            accurate and compliant, however, it cannot guarantee either with
            absolute certainty and cannot be responsible for errors or omissions
            with respect to the information made available through its Services.
            You are responsible for reviewing advertising campaigns and consumer
            communications and making appropriate disclaimers, including with
            respect to pricing errors. If you have administrative access to any
            applications the Company provides (Software, website, third party
            apps, etc.), you are responsible for any actions taken through your
            administrative accounts. If you order the Company’s website
            products, you agree that installing its accessibility solutions is
            required for ADA compliance. If you order Services that include
            prequalified credit offers, you agree to make reasonable efforts to
            process and fund such offers, which you may do through your existing
            lending partners; you further acknowledge that the Company may not
            provide any consumer credit report information directly to you.
            Except as expressly set forth herein, and to the maximum extent
            permitted by Applicable Law, the Company disclaims, on behalf of
            itself and its affiliates, agents, licensors and subcontractors, all
            other representations and warranties, express or implied, including,
            but not limited to, implied warranties of merchantability, fitness
            for a particular purpose, non-infringement, system integration, data
            accuracy, and title.
            <br />
            You acknowledge the following with respect to website services
            provided pursuant to this Agreement:
            <Box pl={"70px"} pt={2} color="black">
              <ol type="a">
                <li>
                  The Company accepts no responsibility for policies of
                  third-party search engines, directories or other web sites
                  (collectively,{" "}
                  <strong>
                    <i>“Third-Party Resources”</i>
                  </strong>{" "}
                  ) that the Company may submit to with respect to the
                  classification or type of content it accepts, whether now or
                  in the future. Your website or content may be excluded or
                  banned from any Third-Party Resource at any time by action of
                  a Third-Party Resource. You agree not to hold the Company
                  responsible for any alleged damage to your website or content
                  or any liability from actions taken by any Third-Party
                  Resource as a result of the implementation of the Services
                  performed by the Company according to the terms of this
                  Agreement.
                </li>
                &nbsp;
                <li>
                  You acknowledge that many of the resources that the Company
                  may employ pursuant to this Agreement are competitive in
                  nature. You further acknowledges that the Company’s past
                  performance is not indicative of any future results you may
                  experience.
                </li>
                &nbsp;
                <li>
                  The Company reserves the exclusive right, for the duration of
                  the Term of this Agreement, to approve or disapprove any
                  design strategies, existing code or other techniques, whether
                  requested by you or anyone presently employed by you, that are
                  considered by the Company to be detrimental to the website and
                  the provision of Services by the Company under this Agreement.
                </li>
              </ol>
            </Box>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>14.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Limitation of Liability.</u>
            </strong>{" "}
            <strong>
              IN NO EVENT SHALL THE COMPANY BE LIABLE TO YOU OR TO ANY THIRD
              PARTY FOR ANY LOSS OF USE, REVENUE OR PROFIT, LOSS OF DATA OR
              DIMINUTION IN VALUE, OR FOR ANY CONSEQUENTIAL, INCIDENTAL,
              INDIRECT, EXEMPLARY, SPECIAL, OR PUNITIVE DAMAGES WHETHER ARISING
              OUT OF BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR
              OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE AND
              WHETHER OR NOT THE COMPANY HAS BEEN ADVISED OF THE POSSIBILITY OF
              SUCH DAMAGES, AND NOTWITHSTANDING THE FAILURE OF ANY AGREED OR
              OTHER REMEDY OF ITS ESSENTIAL PURPOSE.
            </strong>
            <br />
            <strong>
              IN NO EVENT SHALL THE COMPANY’S AGGREGATE LIABILITY ARISING OUT OF
              OR RELATED TO THIS AGREEMENT, WHETHER ARISING OUT OF OR RELATED TO
              BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE) OR OTHERWISE,
              EXCEED THE AGGREGATE AMOUNTS PAID OR PAYABLE TO THE COMPANY
              PURSUANT TO THE AGREEMENT.
            </strong>
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>15.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Indemnification.</u>
            </strong>{" "}
            You agree to indemnify and defend the Company and its subsidiaries,
            affiliates and assigns, and its and their officers, directors,
            members, employees and agents (the{" "}
            <strong>
              <i>“Company Indemnified Parties”</i>
            </strong>{" "}
            ) from and against any and all losses, damages, liabilities,
            deficiencies, claims, actions, judgments, settlements, interest,
            awards, penalties, fines, costs, or expenses of whatever kind,
            including reasonable attorneys’ fees, fees and the costs of
            enforcing any right to indemnification under this Agreement and the
            cost of pursuing any insurance providers (
            <strong>
              <i>“Losses”</i>
            </strong>{" "}
            ) incurred by the Company Indemnified Parties resulting from a
            third-party action, suit or proceeding (
            <strong>
              <i>“Claim”</i>
            </strong>{" "}
            ) as a result of your: (a) gross negligence or willful misconduct;
            or (b) a material breach of any of your representations, warranties,
            and obligations hereunder. You further agree to indemnify and defend
            the Company from any Losses it incurs resulting from a third-party
            Claim that any content or Customer IP you provide the Company for
            use in the Services infringes a U.S. intellectual property right.
            The Company Indemnified Parties shall promptly inform you of any
            Claim for which it may be entitled to indemnification. You may
            direct the defense and settlement of any such Claim, with counsel of
            your choosing. The Company Indemnified Parties will provide you, at
            your expense, with information and assistance reasonably necessary
            to defend and settle the Claim. The Company Indemnified Parties
            shall have the right, but not obligation, at their own expense, to
            participate in, but not control, the defense of any Claim. You will
            not settle any Claim without the written consent of the Company
            Indemnified Parties, not to be unreasonably withheld, conditioned or
            delayed.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>16.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Non-Solicitation.</u>
            </strong>{" "}
            During the Term and for 12 months following its termination, neither
            party, without the other party’s prior written consent, shall,
            directly or indirectly, for itself or any third party: (a) solicit
            or encourage any of the other party’s employees to leave their
            employment; (b) employ or contract with any of the other party’s
            employees; or (c) employ or contract with any person who was
            employed by the other party during the prior 12-month period. This
            does not prohibit hiring responders to general employment ads.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>17.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Governing Law; Venue.</u>
            </strong>{" "}
            The Agreement shall be governed by and construed in accordance with
            the laws of the State of Delaware, without reference to its conflict
            of laws principles. Each party consents to the exclusive
            jurisdiction of the state and federal courts for Denver County,
            Colorado, provided that either party may seek injunctive relief from
            any court of competent jurisdiction. Even if the parties mutually
            agree to an alternative venue, the Company may, to recover unpaid
            fees, file an action in the federal or state courts for Denver
            County, Colorado and you hereby submit to such jurisdiction with
            respect to such action. The prevailing party shall be entitled to
            reasonable attorney fees and costs. The parties waive any rights to
            trial-by-jury.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>18.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>Modifications.</u>
            </strong>{" "}
            The Company may modify these Terms by posting the revised version
            online at least 10 days prior to the end of the then current month,
            effective the 1st of the following month, and will include advance
            notice of any material changes in your invoice, by email and/or
            through the Software. Within this 10-day period, you may notify the
            Company in writing if you wish to terminate the Agreement. The
            Company may then choose to: (a) accept the notice of termination;
            (b) re-modify the Terms; or (c) withdraw the modifications with
            respect to you. Absent such notice by you, you will be deemed to
            have accepted the changes.
          </Text>
          &nbsp;
          <Text variant="body2" color="black">
            <strong>19.</strong> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            <strong>
              <u>General.</u>
            </strong>{" "}
            The Agreement and these Terms: (a) constitute the entire agreement
            between you and the Company and supersedes all prior agreements with
            respect to its subject matter; (b) will be binding upon and inure to
            the benefit of the parties, their successors and permitted assigns;
            (c) creates no agency, partnership or employer-employee relationship
            between the parties (the relationship is that of independent
            contractors); and (d) has no third party beneficiaries (other than
            the Company Indemnified Parties with respect only to the
            Indemnification section). If any provision in the Agreement is
            deemed invalid, illegal, or otherwise unenforceable, such provision
            shall be enforced, as nearly as possible, in accordance with the
            parties’ intent; the remainder shall remain in full force and
            effect. No failure or delay by a party in enforcing the Agreement
            shall be construed as a waiver of any of its rights under it. No
            party shall be deemed in default of the Agreement if the performance
            of its obligations is delayed or prevented by events beyond its
            reasonable control, excluding payment obligations. Notices may be
            delivered electronically, by mail or in person, and shall be deemed
            served when delivered to the address specified in the Agreement;
            each party shall promptly inform the other of any changes to their
            contact information. The Agreement, including any Addendums, may be
            executed electronically or digitally, and/or in counterparts, which
            together will constitute the whole Agreement. Neither party may
            assign the Agreement without the prior written consent of the other
            party, not to be unreasonably withheld, conditioned, or delayed,
            provided that either party may assign the Agreement upon notice to:
            (i) a financially solvent affiliate; or (ii) a
            successor-in-interest, as a result of a merger or consolidation or
            in connection with the sale of all or substantially all of its
            assets. An asset sale shall not relieve you of your obligations to
            pay all amounts outstanding at time of sale; furthermore, unless the
            acquirer assumes the Agreement in connection with the sale, you
            shall remain liable for any fixed fees owed through the remainder of
            the then current Term. The provisions of the Agreement that, by
            their nature, should survive termination of the Agreement, shall
            survive.
          </Text>
          &nbsp;
        </Box>
      </Card>
      <>{number}</>
    </Box>
  );
}
